import { useEffect, useRef } from 'react';
import QRCode from 'qrcode';

/**
 * Rendert einen Wert (z. B. eine otpauth-URL) lokal als QR-Code auf ein Canvas.
 * Bewusst clientseitig — das TOTP-Geheimnis verlässt nie das System (ADR 0034).
 * Genutzt vom Login-Erstsetup (AuthGate) und der Self-Service-2FA (Sicherheit).
 */
export function QrCanvas({ value, size = 200 }: { value: string; size?: number }) {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    if (canvasRef.current) {
      void QRCode.toCanvas(canvasRef.current, value, { width: size, margin: 1 });
    }
  }, [value, size]);

  return <canvas ref={canvasRef} className="rounded border border-border" />;
}
